export function getClientInfo(): {
	os: string;
	os_version: string;
	browser: string;
	browser_version: string;
	device_type: 'Mobile' | 'Tablet' | 'Desktop' | 'Unknown';
	screen_resolution: string;
	connection_type: string;
	user_agent: string;
	locale: string;
	timezone: string;
} {
	const userAgent =
		navigator.userAgent || navigator.vendor || (window as any).opera;

	// OS Detection
	let os = 'Unknown';
	let os_version = 'Unknown';
	let match: RegExpMatchArray | null;

	if (/iP(hone|od|ad)/.test(userAgent)) {
		os = 'iOS';
		match = userAgent.match(/OS (\d+[_\d]+)/);
		if (match) os_version = match[1].replace(/_/g, '.');
	} else if (/Android/.test(userAgent)) {
		os = 'Android';
		match = userAgent.match(/Android\s([0-9\.]+)/);
		if (match) os_version = match[1];
	} else if (/Windows NT/.test(userAgent)) {
		os = 'Windows';
		match = userAgent.match(/Windows NT ([0-9\.]+)/);
		if (match) {
			const versionMap: { [key: string]: string } = {
				'10.0': '10',
				'6.3': '8.1',
				'6.2': '8',
				'6.1': '7',
				'6.0': 'Vista',
				'5.1': 'XP',
			};
			os_version = versionMap[match[1]] || match[1];
		}
	} else if (/Mac OS X/.test(userAgent)) {
		os = 'macOS';
		match = userAgent.match(/Mac OS X (\d+[_\d]+)/);
		if (match) os_version = match[1].replace(/_/g, '.');
	} else if (/Linux/.test(userAgent)) {
		os = 'Linux';
		os_version = 'Unknown';
	}

	// Browser Detection
	let browser = 'Unknown';
	let browser_version = 'Unknown';

	if (/Edg\//.test(userAgent)) {
		browser = 'Microsoft Edge';
		match = userAgent.match(/Edg\/(\d+\.\d+)/);
		if (match) browser_version = match[1];
	} else if (/OPR\//.test(userAgent)) {
		browser = 'Opera';
		match = userAgent.match(/OPR\/(\d+\.\d+)/);
		if (match) browser_version = match[1];
	} else if (
		/Chrome\//.test(userAgent) &&
		!/Edg\//.test(userAgent) &&
		!/OPR\//.test(userAgent)
	) {
		browser = 'Chrome';
		match = userAgent.match(/Chrome\/(\d+\.\d+)/);
		if (match) browser_version = match[1];
	} else if (/Safari\//.test(userAgent) && !/Chrome\//.test(userAgent)) {
		browser = 'Safari';
		match = userAgent.match(/Version\/(\d+\.\d+)/);
		if (match) browser_version = match[1];
	} else if (/Firefox\//.test(userAgent)) {
		browser = 'Firefox';
		match = userAgent.match(/Firefox\/(\d+\.\d+)/);
		if (match) browser_version = match[1];
	} else if (/MSIE\s|Trident\//.test(userAgent)) {
		browser = 'Internet Explorer';
		match = userAgent.match(/(MSIE\s|rv:)(\d+\.\d+)/);
		if (match) browser_version = match[2];
	}

	// Device Type
	let device_type: 'Mobile' | 'Tablet' | 'Desktop' | 'Unknown' = 'Unknown';
	if (/Mobi|Android/i.test(userAgent)) {
		device_type = 'Mobile';
	} else if (/Tablet|iPad/i.test(userAgent)) {
		device_type = 'Tablet';
	} else if (/Macintosh|Windows|Linux|X11/i.test(userAgent)) {
		device_type = 'Desktop';
	}

	// Screen Resolution
	const screen_resolution = `${window.screen.width}x${window.screen.height}`;

	// Connection Type (optional and browser-dependent)
	let connection_type = 'Unknown';
	const navConn = (navigator as any).connection;
	if (navConn && typeof navConn.effectiveType === 'string') {
		connection_type = navConn.effectiveType; // e.g., '4g', '3g', etc.
	}

	// Locale
	const locale = navigator.language || 'Unknown';

	// Timezone
	const timezone =
		Intl.DateTimeFormat().resolvedOptions().timeZone || 'Unknown';

	return {
		os,
		os_version,
		browser,
		browser_version,
		device_type,
		screen_resolution,
		connection_type,
		user_agent: userAgent,
		locale,
		timezone,
	};
}

export function getReferrerInfo() {
	const referrer = document.referrer || '';

	let referrer_domain = '';
	if (referrer) {
		try {
			const url = new URL(referrer);
			referrer_domain = url.hostname;
		} catch (e) {
			console.error('Invalid referrer URL:', e);
		}
	}

	return {
		referrer,
		referrer_domain,
	};
}

export function getUrlComponents() {
	const urlObj = new URL(window.location.href);

	return {
		href: urlObj.href,
		host: urlObj.host,
		pathname: urlObj.pathname,
		url: urlObj.href,
	};
}

export function getTenant() {
	const pathname = window.location.pathname;
	const match = pathname.match(/\/sumo-3p\/([^/]+)/);
	const tenant = match ? match[1] : undefined;
	return {
		tenant,
	};
}